import script from "./qualityTable.vue?vue&type=script&setup=true&lang=js"
export * from "./qualityTable.vue?vue&type=script&setup=true&lang=js"

import "./qualityTable.vue?vue&type=style&index=0&id=f2bcb7ee&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2bcb7ee"]])

export default __exports__